// Fișierul: src/pages/Blog/components/content/curatenie-generala-vs-intretinere-diferente.js

export const content = `
<!-- CASETA TL;DR -->
<div style="background-color: #f8fafc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem auto; max-width: 800px; border-radius: 0 8px 8px 0;">
  <h3 style="margin-top: 0; color: #1e293b; font-size: 1.1rem; font-weight: 700;">TL;DR — Pe scurt</h3>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0;">
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Curățenia generală resetează starea spațiului în profunzime, acoperind zonele greu accesibile (geamuri, calorifere, spatele mobilei).</li>
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Curățenia de întreținere este recurentă (zilnică sau săptămânală) și previne acumularea murdăriei pe suprafețele de uz frecvent.</li>
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Cele două servicii nu se exclud, ci se completează: întreținerea menține standardul obținut prin curățenia generală.</li>
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Într-un birou, ritmul ideal este de întreținere zilnică sau săptămânală plus o curățenie generală trimestrială sau sezonieră.</li>
  </ul>
</div>

<!-- CUPRINS ARTICOL -->
<div style="background-color: #f7f9fc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem 0; border-radius: 0 8px 8px 0;">
  <p style="font-weight: 700; margin-bottom: 0.8rem; color: #1d2a3a;">Cuprins articol:</p>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0; line-height: 1.8;">
    <li><a href="#de-ce-confuzie" style="color: #1a73e8; text-decoration: none; font-weight: 600;">1. De ce se confundă cele două tipuri de curățenie</a></li>
    <li><a href="#ce-este-generala" style="color: #1a73e8; text-decoration: none; font-weight: 600;">2. Ce este curățenia generală</a></li>
    <li><a href="#ce-este-intretinere" style="color: #1a73e8; text-decoration: none; font-weight: 600;">3. Ce este curățenia de întreținere</a></li>
    <li><a href="#diferente-cheie" style="color: #1a73e8; text-decoration: none; font-weight: 600;">4. Diferențele cheie: scop, frecvență, profunzime, echipamente</a></li>
    <li><a href="#cand-generala" style="color: #1a73e8; text-decoration: none; font-weight: 600;">5. Când ai nevoie de curățenie generală</a></li>
    <li><a href="#cand-intretinere" style="color: #1a73e8; text-decoration: none; font-weight: 600;">6. Când ai nevoie de curățenie de întreținere</a></li>
    <li><a href="#tabel-comparativ" style="color: #1a73e8; text-decoration: none; font-weight: 600;">7. Tabel comparativ: generală vs. întreținere</a></li>
    <li><a href="#exemple-practice" style="color: #1a73e8; text-decoration: none; font-weight: 600;">8. Exemple practice: birou și locuință</a></li>
    <li><a href="#concluzie" style="color: #1a73e8; text-decoration: none; font-weight: 600;">9. Concluzie</a></li>
    <li><a href="#faq" style="color: #1a73e8; text-decoration: none; font-weight: 600;">10. Întrebări frecvente</a></li>
  </ul>
</div>

<p>Mulți clienți solicită „curățenie generală” atunci când, de fapt, au nevoie de un contract recurent de întreținere, sau invers — se așteaptă ca o curățenie de întreținere să acopere sarcini grele care aparțin în mod normal unei curățenii generale. Confuzia vine din faptul că ambele servicii folosesc proceduri similare de igienizare, dar diferă fundamental ca scop, frecvență și nivel de profunzime.</p>

<p>Alegerea corectă influențează atât rezultatul vizual, cât și bugetul: o curățenie de întreținere prea rară lasă murdăria să se acumuleze și să deterioreze materialele, în timp ce o curățenie generală prea frecventă reprezintă un cost nejustificat pentru un spațiu deja bine îngrijit.</p>

<!-- IMAGINE PRINCIPALA -->
<div style="margin: 2rem auto; text-align: center; max-width: 100%; width: 700px;">
  <img src="https://i.ibb.co/N6dM6f7c/Whats-App-Image-2026-09-16-at-10-49-36.webp" alt="diferenta curatenie generala curatenie intretinere birou locuinta" style="width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
</div>

<h2 id="de-ce-confuzie">De ce se confundă cele două tipuri de curățenie</h2>
<p>În limbajul curent, expresia „facem curățenie” poate însemna orice, de la aspiratul de vineri până la spălatul geamurilor și degresatul faianței. În domeniul serviciilor profesionale, delimitarea este precisă:</p>
<p>Serviciul de <a href="/curatenie-generala/">curățenie generală</a> vizează aducerea spațiului la standardul zero de murdărie, în timp ce serviciul de <a href="/curatenie-de-intretinere/">curățenie de întreținere</a> păstrează acel standard pe o perioadă nedeterminată prin intervenții programate.</p>

<h2 id="ce-este-generala">Ce este curățenia generală</h2>
<p>Curățenia generală este o intervenție punctuală, minuțioasă și de mare profunzime, care acoperă absolut toate suprafețele unui spațiu, inclusiv cele greu accesibile:</p>
<ul>
  <li>în spatele și sub corpurile de mobilier masiv sau electrocasnice;</li>
  <li>spălarea geamurilor interior-exterior, a ramelor, tocurilor și garniturilor;</li>
  <li>degresarea completă a bucătăriei (hota, plita, faianța până la tavan);</li>
  <li>decalcifierea și dezinfectarea integrală a grupurilor sanitare;</li>
  <li>ștergerea corpurilor de iluminat, a prizelor, întrerupătoarelor și caloriferelor;</li>
  <li>curățarea ușilor, tocurilor și plintelor pe toată lungimea lor.</li>
</ul>
<p>Se recomandă sezonier (primăvara și toamna), la mutare, înainte/după evenimente festive sau atunci când spațiul nu a mai fost curățat temeinic de câteva luni.</p>

<h2 id="ce-este-intretinere">Ce este curățenia de întreținere</h2>
<p>Curățenia de întreținere este un serviciu recurent, de regulă derulat pe bază de contract lunar, care menține un nivel optim de igienă între două curățenii generale. Se concentrează pe zonele cu trafic intens și pe suprafețele de uz zilnic:</p>
<ul>
  <li>aspirarea și spălarea pardoselilor;</li>
  <li>igienizarea și dezinfectarea vaselor de toaletă și a chiuvetelor;</li>
  <li>ștergerea prafului de pe birouri, mese și suprafețe libere;</li>
  <li>colectarea și evacuarea deșeurilor menajere, înlocuirea sacilor de gunoi;</li>
  <li>curățarea chiuvetei de bucătărie și a blatului de lucru.</li>
</ul>
<p>Pentru companii, serviciile de <a href="/curatenie-birouri-firme-spatii-comerciale/">curățenie pentru birouri și spații comerciale</a> se bazează în primul rând pe acest abonament de întreținere, desfășurat zilnic sau de câteva ori pe săptămână.</p>

<h2 id="diferente-cheie">Diferențele cheie: scop, frecvență, profunzime, echipamente</h2>
<ul>
  <li><strong>Scopul:</strong> Curățenia generală resetează starea spațiului; curățenia de întreținere previne acumularea murdăriei și degradarea finisajelor.</li>
  <li><strong>Frecvența:</strong> Curățenia generală se face punctual sau la intervale mari (trimestrial, semestrial); curățenia de întreținere este recurentă (zilnică sau săptămânală).</li>
  <li><strong>Profunzimea:</strong> Generală ajunge în toate colțurile și spațiile ascunse; întreținerea acoperă suprafețele vizibile și de uz curent.</li>
  <li><strong>Timp și echipă alocată:</strong> Curățenia generală necesită o echipă mai numeroasă pe o durată extinsă (adesea o zi întreagă) și utilaje speciale (monodisc, aspirator injecție-extracție, generator de abur); întreținerea este optimizată pentru rapiditate, regularitate și discreție.</li>
</ul>

<h2 id="cand-generala">Când ai nevoie de curățenie generală</h2>
<p>Apelează la curățenie generală în următoarele situații:</p>
<ul>
  <li>la schimbarea chiriașilor sau la mutarea într-o nouă locuință ori birou;</li>
  <li>după o perioadă lungă în care spațiul a fost neglijat sau s-au acumulat pete greu de scos;</li>
  <li>sezonier, pentru revigorarea completă a aerului și a suprafețelor;</li>
  <li>înainte de controale sanitare, audituri sau vizite importante ale partenerilor de afaceri;</li>
  <li>înainte sau după petreceri ori evenimente ample.</li>
</ul>

<h2 id="cand-intretinere">Când ai nevoie de curățenie de întreținere</h2>
<p>Curățenia de întreținere este alegerea ideală dacă:</p>
<ul>
  <li>ai un sediu de firmă, cabinet sau birou cu flux constant de angajați și clienți;</li>
  <li>îți dorești un standard permanent de curățenie fără a investi timp personal;</li>
  <li>ai finalizat recent o curățenie generală și dorești să-i prelungești efectele;</li>
  <li>ai nevoie de un program predictibil și un buget lunar fix pentru curățenie.</li>
</ul>

<h2 id="tabel-comparativ">Tabel comparativ: generală vs. întreținere</h2>
<div style="overflow-x: auto; margin: 2rem 0;">
  <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 0.95rem;">
    <thead>
      <tr style="background-color: #f1f5f9; border-bottom: 2px solid #cbd5e1;">
        <th style="padding: 12px; font-weight: 700;">Criteriu</th>
        <th style="padding: 12px; font-weight: 700;">Curățenie generală</th>
        <th style="padding: 12px; font-weight: 700;">Curățenie de întreținere</th>
      </tr>
    </thead>
    <tbody>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Frecvență</td>
        <td style="padding: 12px;">Punctual / periodic (sezonier, 2-4 ori/an)</td>
        <td style="padding: 12px;">Recurent: zilnic, de 2-3 ori/săptămână sau săptămânal</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Profunzime</td>
        <td style="padding: 12px;">Toate zonele, inclusiv colțuri, geamuri și spatele mobilierului</td>
        <td style="padding: 12px;">Suprafețe de uz zilnic (pardoseli, baie, bucătărie, birouri)</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Durată sesiune</td>
        <td style="padding: 12px;">Extinsă (4-8 ore sau mai mult)</td>
        <td style="padding: 12px;">Scurtă, optimizată pentru eficiență</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Echipamente</td>
        <td style="padding: 12px;">Monodisc, injecție-extracție, abur, scări/schele</td>
        <td style="padding: 12px;">Aspiratoare profesionale, cărucioare, mopuri codificate</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Recomandat pentru</td>
        <td style="padding: 12px;">Mutări, evenimente, curățenie sezonieră</td>
        <td style="padding: 12px;">Birouri, cabinete, locuințe locuite permanent</td>
      </tr>
    </tbody>
  </table>
</div>

<h2 id="exemple-practice">Exemple practice: birou și locuință</h2>

<h3>Exemplul 1: Birou cu contract integrat</h3>
<ul>
  <li><strong>Întreținere zilnică:</strong> Golirea coșurilor, dezinfectarea băilor comune, igienizarea zonei de cafea, aspirarea mochetelor pe căile de acces, ștergerea birourilor libere.</li>
  <li><strong>Generală trimestrială:</strong> Spălarea geamurilor pe ambele fețe, curățarea mecanizată prin injecție-extracție a mochetelor, igienizarea scaunelor tapițate, ștergerea corpurilor de iluminat și a grilelor de ventilație.</li>
</ul>

<h3>Exemplul 2: Apartament sau vilă</h3>
<ul>
  <li><strong>Întreținere săptămânală:</strong> Spălarea pardoselilor, curățarea căzii și a chiuvetei, aspirarea covoarelor, ștergerea prafului de pe mobilierul accesibil.</li>
  <li><strong>Generală sezonieră (primăvară/toamnă):</strong> Curățarea detaliată a cuptorului și hotei la interior, mutarea mobilierului ușor, spălarea perdelelor/geamurilor, decalcifierea faianței și a rosturilor.</li>
</ul>

<h2 id="concluzie">Concluzie</h2>
<p>Cele două servicii nu se exclud, ci lucrează împreună: curățenia generală oferă fundamentul impecabil, iar curățenia de întreținere protejează investiția zi de zi. Alegerea corectă depinde de traficul din spațiu, de starea inițială și de obiectivele pe termen lung.</p>
<p>Echipa Doral Cleaning pune la dispoziție atât pachete flexibile de curățenie generală, cât și abonamente adaptate de întreținere pentru persoane fizice și companii din București și Ilfov.</p>

<h2 id="faq">Întrebări frecvente</h2>
<p><strong>Pot avea doar curățenie de întreținere, fără curățenie generală periodică?</strong><br/>
Este posibil pe termen scurt, dar nerecomandat pe termen lung: fără intervenții periodice în profunzime, zonele ascunse acumulează praf și calcar care nu pot fi îndepărtate în timpul alocat unei ședințe de întreținere.</p>

<p><strong>Cât de des ar trebui făcută o curățenie generală într-un birou?</strong><br/>
De regulă sezonier (de 2-4 ori pe an), programată adesea în weekend pentru a completa eficient contractul de întreținere săptămânală.</p>

<p><strong>Curățenia de întreținere include și spălarea geamurilor exterioare?</strong><br/>
Nu de obicei — spălarea completă a geamurilor, mai ales la exterior sau la înălțime, este o operațiune specializată inclusă în curățenia generală sau contractată ca serviciu distinct.</p>

<p><strong>Ce se întâmplă dacă aleg curățenie generală în loc de întreținere pentru un spațiu cu trafic zilnic?</strong><br/>
Rezultatul impecabil se va degrada rapid în câteva zile din cauza prafului și a traficului, iar costul per sesiune va fi disproporționat față de beneficiul unui abonament constant.</p>

<div style="background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%); border-radius: 12px; padding: 2rem; margin: 2.5rem 0; text-align: center; color: #fff;">
  <p style="font-size: 1.15rem; font-weight: 600; margin-bottom: 0.5rem;">Ai nevoie de consultanță pentru alegerea serviciului potrivit?</p>
  <p style="margin-bottom: 1.2rem; opacity: 0.92;">Contactează specialiștii Doral Cleaning pentru o evaluare rapidă și o ofertă personalizată nevoilor tale.</p>
  <a href="/contact-curatenie" style="background:#fff; color:#1a73e8; font-weight:700; padding:0.65rem 1.75rem; border-radius:8px; text-decoration:none; display:inline-block;">Solicită o ofertă</a>
</div>
`;

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Pot avea doar curățenie de întreținere, fără curățenie generală periodică?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Este posibil, dar nerecomandat pe termen lung: fără o curățenie generală periodică, zonele greu accesibile acumulează murdărie care nu este acoperită de curățenia de întreținere."
      }
    },
    {
      "@type": "Question",
      "name": "Cât de des ar trebui făcută o curățenie generală într-un birou?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "De obicei sezonier (de 2-4 ori pe an), în completarea unui contract de curățenie de întreținere zilnică sau săptămânală."
      }
    },
    {
      "@type": "Question",
      "name": "Curățenia de întreținere include și spălarea geamurilor sau a pardoselilor cu tratamente?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Nu de obicei — acestea sunt servicii specializate, tratate separat sau incluse punctual în curățenia generală, în funcție de contract."
      }
    },
    {
      "@type": "Question",
      "name": "Ce se întâmplă dacă aleg curățenie generală în loc de întreținere pentru un spațiu cu trafic zilnic?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Rezultatul se degradează rapid între sesiuni, pentru că un spațiu cu trafic constant are nevoie de intervenții recurente, nu doar de resetări punctuale."
      }
    }
  ]
};
